// Loom OAuth callbacks may carry attribution in the continue destination.
// Preserve direct query parameters and use continue only for missing values.
export function getLoomSignupQueryParams(search = window.location.search): URLSearchParams {
  const params = new URLSearchParams(search);
  const continueUrl = params.get('continue');
  if (continueUrl) {
    try {
      const nestedParams = new URL(continueUrl, window.location.origin).searchParams;
      ['sn_id', 'loom_anon_id', 'flowTraceId'].forEach(key => {
        const value = nestedParams.get(key);
        if (!params.get(key) && value) {
          params.set(key, value);
        }
      });
    } catch {
      // Ignore malformed continue URLs and keep using direct parameters.
    }
  }
  return params;
}
